export default "__VITE_ASSET__96b7aa28__"